import { DEFAULT_COUNT_ON_PAGE } from '@shared/ui/pagination/constants';
import { RequestsListDataRequest } from '../api/request-types';
import { RequestStatus } from '@shared/model/request';

export const DEFAULT_REQUEST_LIST_STATUSES = `${RequestStatus.New},${RequestStatus.OrderForming},${RequestStatus.Request_reject},${RequestStatus.Canceled}`;

export const DEFAULT_REQUESTS_LIST_PARAMETERS: RequestsListDataRequest = {
    search: '',
    take: DEFAULT_COUNT_ON_PAGE.value,
    skip: null,
    order: 'created_at',
    sort: 'desc',
    statuses: DEFAULT_REQUEST_LIST_STATUSES,
};
